// ─────────────────────────────────────────────────────────────────
// Glass-i — Process Master API client (Stage 6B.8A-3K).
//
// Thin axios wrappers around /api/erp/masters/processes/*. Mirrors
// the glassConceptsApi / itemsApi pattern: same envelope unwrap.
// The spreadsheet UI fires `bulkSave` from "Save Changes".
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/processes';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const processMasterApi = {
  list:      (params = {}) =>
    client.get(BASE, { params }).then(unwrap),
  get:       (id) =>
    client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:    (payload) =>
    client.post(BASE, payload).then(unwrap),
  update:    (id, payload) =>
    client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:    (id) =>
    client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  duplicate: (id) =>
    client.post(`${BASE}/${encodeURIComponent(id)}/duplicate`, {}).then(unwrap),
  bulkSave:  (payload) =>
    client.post(`${BASE}/bulk-save`, payload).then(unwrap),
  resolveRate: (id, payload) =>
    client.post(`${BASE}/${encodeURIComponent(id)}/resolve-rate`, payload).then(unwrap)
};

// ── Curated frontend dropdown options ────────────────────────────
export const UOM_OPTIONS = [
  'RFT', 'RMT', 'SQF', 'SQFT', 'SQM', 'SQMT', 'PCS', 'SET', 'QTY'
].map((v) => ({ value: v, label: v }));

export const DEPARTMENT_OPTIONS = [
  { value: 'POLISH',       label: 'POLISH' },
  { value: 'DESIGN',       label: 'DESIGN' },
  { value: 'PAINT',        label: 'PAINT' },
  { value: 'CUTTING',      label: 'CUTTING' },
  { value: 'INSTALLATION', label: 'INSTALLATION' },
  { value: 'OTHERS',       label: 'OTHERS' }
];

export const CATEGORY_OPTIONS = [
  'CLEAR', 'TINTED', 'REFLECTIVE', 'EXTRA CLEAR',
  'MIRROR', 'LACQUERED', 'FLUTED', 'SPECIAL', 'OTHER'
].map((v) => ({ value: v, label: v }));

export const DEFAULT_THICKNESSES = [4, 5, 6, 8, 10, 12, 15, 19];

export default processMasterApi;
